import { Alert, Box, Flex, Grid } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { DisconnectedAlert } from '../DisconnectedAlert/DisconnectedAlert';
import { NoBudgets } from '../NoBudgets/NoBudgets';
import { messages } from './BudgetListWrapper.messages';
import { BudgetListWrapperProps } from './BudgetListWrapper.types';

export const BudgetListWrapper = memo<BudgetListWrapperProps>((props) => {
    const { isDisconnected, hasBudgets, canCreateBudget, isError, onUploadNewBudget, children } = props;

    if (isError && !isDisconnected) {
        return (
            <Box spacing='16 0 0'>
                <Alert invalid color='midnight20'>
                    {messages.errorMessage}
                </Alert>
            </Box>
        );
    }

    if (!hasBudgets || isDisconnected) {
        return (
            <Flex height='100%' alignItems='center' justifyContent='center'>
                <NoBudgets canCreateBudget={canCreateBudget} onUploadNewBudget={onUploadNewBudget} />
            </Flex>
        );
    }

    return (
        <Grid rowGap={16}>
            {isDisconnected && <DisconnectedAlert inline />}

            {children}
        </Grid>
    );
});

BudgetListWrapper.displayName = 'BudgetListWrapper';
